<template>
    <div class="flex items-center mt-5">
        <h2 class="block text-sm font-medium text-gray-700 ">{{ label }} <span v-if="requires == 'True'" class="text-red-500 text-xs" > *</span>
        </h2>
        <Tooltip v-if="tooltip" class="" :tooltip="tooltip" />
    </div>

    <div class="my-3 items-center flex">

        <BaseRadioButton v-for="option in options" :key="option.id" :checked="option.title === modelValue"
            :value="option.title" :label="option.title" :name="group"
            @change="$emit('update:modelValue', $event.target.value)" />
    </div>

</template>
  
<script setup>

import BaseRadioButton from './BaseRadioButton.vue';

import { inject } from 'vue';
import Tooltip from './Tooltip.vue';

const form = inject('form');

const props = defineProps({
    options: {
        type: Array,
        required: true,
    },
    label: {
        type: String,
        default: ''
    },
    requires: {
        type: String,
        default: 'false'
    },
    group: {
        type: String,
    },
    tooltip: {
        type: String,
        default: ''
    },
    modelValue: {
        type: [String, Number],
        default: ''
    },
    value: {
        type: [String, Number],
        default: ''
    },
})



</script>